export enum WebchargeStatus {
  PENDING_INITIAL = 'PENDING_INITIAL',
  PENDING_WAITING_FOR_PAYMENT = 'PENDING_WAITING_FOR_PAYMENT',
  PENDING_PAID = 'PENDING_PAID',
  SUCCESS_WEBCHARGE_COMPLETED = 'SUCCESS_WEBCHARGE_COMPLETED',
  WARNING_WEBCHARGE_ALREADY_EXISTING = 'WARNING_WEBCHARGE_ALREADY_EXISTING',
  ERROR_CARD_UNKNOWN = 'ERROR_CARD_UNKNOWN',
  ERROR_PAYMENT = 'ERROR_PAYMENT',
  ERROR_EXPIRED = 'ERROR_EXPIRED',
  ERROR_UNKNOWN = 'ERROR_UNKNOWN',
}
